export default "__VITE_ASSET__Bc5J$Dr0__"